import { render, staticRenderFns } from "./ConfirmPage.vue?vue&type=template&id=406a19da&"
import script from "./ConfirmPage.vue?vue&type=script&lang=js&"
export * from "./ConfirmPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports